const initState = {
    isFetching: false
}

const providerReducer = (state = initState, action) => {
    switch (action.type) {
        case 'GET_PROVIDER':
            return action.data;      

        case 'GET_PROVIDER_FAILED':
            return action.data;    

        case 'DELETE_PROVIDER':
            return action.data;      

        case 'DELETE_PROVIDER_FAILED':
            return action.data;    

        case 'CREATING_PROVIDER':
            return {
                ...action.data, 
                isFetching: true
            };

        case 'CREATE_PROVIDER':
            return {
                ...action.data, 
                isFetching: false
            };

        case 'CREATE_PROVIDER_FAILED':
            return {
                ...action.data, 
                isFetching: false
            };

        case 'UPDATING_PROVIDER':
            return {
                ...action.data, 
                isFetching: true
            };

        case 'UPDATE_PROVIDER':
            return {
                ...action.data, 
                isFetching: false
            };

        case 'UPDATE_PROVIDER_FAILED':
            return {
                ...action.data, 
                isFetching: false
            };         

        default:
            return state;
    }
}

export default providerReducer;